<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalReceivedDateVisible" :vm-is-valid="!$v.received_date.$invalid" vm-title='Add Received Date')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("projects.date")' :danger="$v.received_date.$invalid && $v.received_date.$model" :danger-text="$t('validation.required', { attribute: $t('shipment.received_date') })" v-model="received_date")
</template>
<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalReceivedDate',
  props: {
    shipmentId: {
      type: Number
    }
  },
  data: () => ({
    received_date: ''
  }),
  validations: {
    received_date: {
      required
    }
  },
  computed: {
    ...mapGetters([
      'isModalReceivedDateVisible'
    ])
  },
  methods: {
    ...mapActions([
      'setModalReceivedDateVisible',
      'addReceivedDate'
    ]),
    saveRecord () {
      this.addReceivedDate({ data: this.received_date, id: this.shipmentId })
    },
    close () {
      this.setModalReceivedDateVisible(false)
    }
  }
}
</script>
